dotvvm.events.initCompleted.subscribe(() => updateMobileStepper());
dotvvm.events.newState.subscribe(() => updateMobileStepper());

const updateMobileStepper = () => {
    const currentStep = dotvvm.state.Model.Step;
    const maxSteps = 6;
    const progressValue = Math.round((currentStep / maxSteps) * 100);
    document.getElementById("mobile-stepper").style.setProperty('--progress', progressValue + '%');
};